import { render, staticRenderFns } from "./PayrollEmployees.vue?vue&type=template&id=389f5fa8&"
import script from "./PayrollEmployees.vue?vue&type=script&lang=ts&"
export * from "./PayrollEmployees.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports